const defaultColumnsByBreakpoint = {
  0: 2,
  768: 3,
  1024: 4,
};

// Same breakpoints Grid.module.scss hardcodes for its own gap; kept in sync manually.
const gapByBreakpoint = {
  0: 16,
  768: 24,
};

const jldsBreakpoints = {
  sm: "0",
  md: "600",
  lg: "1280",
  xl: "1440",
};

export const ColumnStyles = ({
  columnsByBreakpoint,
  className,
}: {
  columnsByBreakpoint: unknown;
  className: string;
}) => (
  <style>
    {[
      ...Object.entries(validateColumnsByBreakpoint(columnsByBreakpoint)).map(
        ([breakpoint, columns]) => `
              @media (min-width: ${getBreakpoint(breakpoint)}) {
                .${className} { --columns: ${columns}; }
              }
            `,
      ),
      ...Object.entries(gapByBreakpoint).map(
        ([breakpoint, gap]) => `
              @media (min-width: ${getBreakpoint(breakpoint)}) {
                .${className} { --gap: ${gap}px; }
              }
            `,
      ),
    ].join("\n")}
  </style>
);

const validateColumnsByBreakpoint = (
  columnsByBreakpoint: unknown,
): Record<string, number> => {
  if (!columnsByBreakpoint || typeof columnsByBreakpoint !== "object") {
    return defaultColumnsByBreakpoint;
  }
  // Validate that all values are numbers, discard any non-number values
  // Validate that all keys are valid breakpoints (sm, md, lg, xl or a number string)
  const validBreakpoints = ["sm", "md", "lg", "xl"];
  const validatedColumnsByBreakpoint: Record<string, number> = {};
  for (const [breakpoint, columns] of Object.entries(columnsByBreakpoint)) {
    if (
      (validBreakpoints.includes(breakpoint) ||
        !isNaN(parseInt(breakpoint, 10))) &&
      typeof columns === "number"
    ) {
      validatedColumnsByBreakpoint[breakpoint] = columns;
    }
  }
  // If no valid breakpoints were found, return the standard columns by breakpoint
  if (Object.keys(validatedColumnsByBreakpoint).length === 0) {
    return defaultColumnsByBreakpoint;
  }
  // If there is no "sm" or "0" breakpoint, add it with the standard value
  if (!validatedColumnsByBreakpoint.sm && !validatedColumnsByBreakpoint["0"]) {
    validatedColumnsByBreakpoint.sm = defaultColumnsByBreakpoint[0];
  }
  return validatedColumnsByBreakpoint;
};

const getBreakpoint = (width: string) => {
  if (width in jldsBreakpoints) {
    return `${jldsBreakpoints[width as keyof typeof jldsBreakpoints]}px`;
  }

  return `${parseInt(width, 10)}px`;
};
